<template>
  <transition>
    <div class="experiment-group">
      <div class="c-data-content c-data-content__data c-data-content__experiment c-data-content--row">
        <div class="c-data-content__experiment--title">
          <h4>{{ title }}</h4>
        </div>
        <div class="c-data-content__experiment--state" :class="stateClass">
          <h4>{{ stateText }}</h4>
        </div>
        <div class="c-data-content__experiment--ctr">
          <h4>+{{ ctrIncrement }}%</h4>
        </div>
        <div class="c-data-content__experiment--data">
          <h4>{{ dateText }}</h4>
        </div>
        <div class="c-data-content__experiment--editor">
          <h4>{{ authorName }}</h4>
        </div>
        <div class="c-data-content__experiment--client">
          <h4>{{ experiment.client.name }}</h4>
        </div>
        <div class="c-data-content__experiment--details has-subitems" :class="{ open: isDetailsShowed }" v-on:click="toggleDetails">
          <h4>{{ $t('experiments.table.details')}}</h4>
        </div>
      </div>

      <experiments-details
          v-for="(option, index) in experiment.options" :key="option.id"
          :isWinner="isOptionWinner(option)"
          v-show="isDetailsShowed"
          :title="option.content"
          :index="index"
          :isOriginal="option.is_original"
          :ctr="ctr(option.stats.clicks, option.stats.views)"
          :clicks="option.stats.clicks"
          :views="option.stats.views"
          :viewBar="viewBar(option)"
          :clickBar="clickBar(option)"
        />
    </div>
  </transition>
</template>

<script>
import ExperimentsDetails from './ExperimentsDetails.vue'

export default {
  name: 'ExperimentsRow',
  components: {
    ExperimentsDetails,
  },
  props: {
    experiment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isDetailsShowed: false,
    }
  },
  computed: {
    title() {
      const originalOption = this.experiment.options.filter(
        (option) => option.is_original,
      )

      return originalOption.length === 1 ? originalOption[0].content : ''
    },
    authorName() {
      const { name, firstname } = this.experiment.created_by

      return [name, firstname]
        .filter((v) => v !== null)
        .join(' ')
    },
    stateText() {
      const { state } = this.experiment

      switch (state) {
        case 'running':
        case 'stand_by':
          return this.$t('experiments.table.active')
        default:
          return this.$t('experiments.table.finished')
      }
    },
    stateClass() {
      const { state } = this.experiment

      switch (state) {
        case 'running':
        case 'stand_by':
          return 'is-active'
        default:
          return 'is-finish'
      }
    },
    dateText() {
      return this.$moment(this.experiment.end_date).fromNow()
    },
    ctrIncrement() {
      let original = null
      const { options } = this.experiment

      options.forEach((option) => {
        if (option.is_original) {
          original = option
        }
      })

      if (original === null) {
        return 0
      }

      const sorted = this.experimentOptionsSorted()
      const orignalCtr = this.ctr(original.stats.clicks, original.stats.views)
      const bestCtr = this.ctr(sorted[0].stats.clicks, sorted[0].stats.views)
      const ctr = bestCtr - orignalCtr
      const isNan = Number.isNaN(ctr)

      if (isNan) return 0

      return ctr > 0 ? ctr.toFixed(2).replace(/\.00/, '') : ctr
    },
  },
  methods: {
    toggleDetails() {
      this.isDetailsShowed = !this.isDetailsShowed
    },
    ctr(clicks, views) {
      if (views === 0) {
        return 0
      }

      return (clicks / views) * 100
    },
    experimentOptionsSorted() {
      return [...this.experiment.options].sort((optionA, optionB) => {
        const ctrA = this.ctr(optionA.stats.clicks, optionA.stats.views)
        const ctrB = this.ctr(optionB.stats.clicks, optionB.stats.views)

        return ctrB - ctrA
      })
    },
    isOptionWinner(option) {
      const { state } = this.experiment

      if (state === 'running' || state === 'stand_by') {
        return false
      }

      const sorted = this.experimentOptionsSorted()

      return sorted[0].id === option.id
    },
    viewBar(option) {
      const value = (option.stats.views * 100) / (option.stats.views + option.stats.clicks)
      return `width:${value}%`
    },
    clickBar(option) {
      const value = (option.stats.clicks * 100) / (option.stats.views + option.stats.clicks)
      return `width:${value}%`
    },
  },
}
</script>
